import { examInfo } from './type'

const info: examInfo = {
  examGroupKey: '51220091',
  type: 'MAGAZINE',
  title: '『小学一年生』９月号に掲載の「小学館思考力テスト」',
  semiTitle: '小学館思考力テスト',
  signInMessage: '『小学一年生』9月号とじ込みの「小学館思考力テスト」',
  page: 2,
  howToApproach: 'テストに取り組む',
  hasAdviceSheet: true,
  timeRequiredForReturn: 2,
  noteOnRegistration: 'こちらへのご登録が、名探偵コナンゼミへの入会登録となることはありませんが、各種ご案内をする場合があります。',
  showIsKaiin: true,
  endTo: '2023/3/31(金)',
  registEndTo: '2022/11/1',
  bannerLink: 'https://conan-zemi.shopro.co.jp/tsushin/image/sho1/samplebook_v2.pdf?utm_source=sho1_shikotest&utm_medium=referral&utm_campaign=sho1_shikotest&utm_id=sho1_shikotest&utm_content=sho1_shikotest2208',
  enqueteStart: '2022/08/4 13:00',
  enqueteEnd: '2022/11/30(水) 23:59',
  enqueteUrl: 'https://questant.jp/q/GVVH52QG',
  qrFaqId: 6,
  requireInputAddress: true,
}

export default info;
